"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalTxDocumentBuilder = void 0;
var TxRelatedId_1 = require("../common/TxRelatedId");
var InternalTxDocumentBuilder = /** @class */ (function () {
    function InternalTxDocumentBuilder() {
    }
    InternalTxDocumentBuilder.build = function (tx, block, confirmed, chainId) {
        var chain = Number(chainId);
        return {
            id: TxRelatedId_1.TxRelatedId.create(chain, tx.transactionHash),
            hash: tx.transactionHash,
            chainId: chain,
            from: tx.from,
            to: tx.to,
            value: tx.value,
            gas: parseInt(tx.gas || '0', 10),
            blockHash: block.hash,
            blockTimestamp: parseInt(block.timestamp, 10),
            blockNumber: parseInt(block.number, 10),
            confirmed: confirmed,
        };
    };
    return InternalTxDocumentBuilder;
}());
exports.InternalTxDocumentBuilder = InternalTxDocumentBuilder;
//# sourceMappingURL=InternalTxDocumentBuilder.js.map